export function computeDeliveryDate(now, shippingDays) {
  const result = new Date(now);
  let remainingDays = shippingDays;
  while (remainingDays > 0) {
    result.setDate(result.getDate() + 1);
    if (result.getDay() !== 0) {
      // 0 = Sunday, excluded from the count
      remainingDays -= 1;
    }
  }
  return result;
}

export function secondsUntil(now, targetTimeHHMMSS) {
  const [h, m, s] = targetTimeHHMMSS.split(':').map(Number);
  const target = new Date(now);
  target.setHours(h, m, s, 0);
  if (target.getTime() <= now.getTime()) {
    target.setDate(target.getDate() + 1);
  }
  return Math.floor((target.getTime() - now.getTime()) / 1000);
}

function formatCountdown(totalSeconds) {
  const clamped = Math.max(0, totalSeconds);
  const h = Math.floor(clamped / 3600);
  const m = Math.floor((clamped % 3600) / 60);
  const s = clamped % 60;
  return [h, m, s].map((n) => String(n).padStart(2, '0')).join(':');
}

const BaseElement = typeof HTMLElement !== 'undefined' ? HTMLElement : class {};

class WarblueEstimatedShipping extends BaseElement {
  connectedCallback() {
    const targetTime = this.dataset.targetTime;
    const shippingDays = Number(this.dataset.shippingDays);
    const disableCountdown = this.dataset.disableCountdown === 'true';
    const countdownEl = this.querySelector('[data-wes-countdown]');
    const deliveryEl = this.querySelector('[data-wes-delivery]');

    const renderDelivery = () => {
      const now = new Date();
      const deliveryDate = computeDeliveryDate(now, shippingDays);
      const locale = document.documentElement.lang || 'en';
      // Abbreviated month ("Sep 25" instead of "September 25") so the whole
      // bar reliably fits on one line on narrow phone widths.
      deliveryEl.textContent = new Intl.DateTimeFormat(locale, {
        day: 'numeric',
        month: 'short',
      }).format(deliveryDate);
    };

    renderDelivery();

    if (disableCountdown || !countdownEl) return;

    const tick = () => {
      const remaining = secondsUntil(new Date(), targetTime);
      countdownEl.textContent = formatCountdown(remaining);
    };
    tick();
    this._interval = setInterval(tick, 1000);
  }

  disconnectedCallback() {
    if (this._interval) clearInterval(this._interval);
  }
}

if (typeof customElements !== 'undefined') {
  customElements.define('warblue-estimated-shipping', WarblueEstimatedShipping);
}
